import UpdateGameRoutes from '../../components/gameRoute/UpdateGameRoute';

const GameRoutesUpdate = () => {
  return (
    <div className="flex flex-col items-cener gap-5 p-10 h-full">
      <div className="bg-gradient-to-r from-darkPurple to-softPurple w-full p-5 h-auto">
        <p className="text-white">Maršrutų atnaujinimas</p>
      </div>
      <div className="flex justify-center h-full">
        <UpdateGameRoutes />
      </div>
    </div>
  );
};

export default GameRoutesUpdate;
